module.exports = "file2";


/*****************
 ** WEBPACK FOOTER
 ** ./runtime/error-handling/folder/file2.js
 ** module id = 2
 ** module chunks = 0
 **/